import React from 'react'
// import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { graphql, compose } from 'react-apollo'
import _get from 'lodash/get'
import _flatten from 'lodash/flatten'
import _entries from 'lodash/entries'
import moment from 'moment'
import CatchmentControl from '~/components/CatchmentControl'
import StationControl from './StationControl'

import DataTypeControl from '~/components/DataTypeControl'

import ResponseDataChart from './ResponseDataChart'
import ForcingDataChart from './ForcingDataChart'
import { Section, ControlSection, ChartSection } from '~/components/styles'
import categoriesQuery from '~/graphql/queries/categories.gql'
import config from '~/config'
import { toJS } from 'mobx'
const { categories } = config.app

const Controls = ({ view: { mode, catchmentId, stationIds, dataTypeIds }, data, responseCategories, forcingCategories }) => {
  const today = moment(data.now).clone().set({ hour: 0, minute: 0, second: 0 })
  // const { stations } = data
  // TODO: check data.responseData.busy()
  // console.log('x', dataTypeIds.responßse)
  const responseData = data.responseData.get()
  const $responseData = (category) => {
    const responseDataTypeIds = toJS(dataTypeIds.response)[category.id]// dataTypeIds.response.get(category.id)
    if (!responseData || !responseData[category.id]) {
      return <div style={{ width: '100%', color: 'black' }}></div>
    }
    // console.log({responseData})
    // const responseDataTypeIds = dataTypeIds.response.get(category.id).toJS()
    const data = _flatten(
      _entries(responseData[category.id]).map(([stationId, stationData]) => {
        return _flatten(stationData).map(
          d => ({ ...d, typeName: d.type.name })
        )
      })
    )
    // const data = _flatten(responseData[category.id]).map(
    //   d => ({ ...d, typeName: d.type.name })
    // )
    return <ResponseDataChart dataRecords={data} dataTypeIds={responseDataTypeIds} category={category} key={category.id} today={today} />
  }
  // console.log({stationIds, sl: stationIds.length, responseCategories})
  const forcingData = data.forcingData.get()
  const $forcingData = (category) => {
    const forcingDataTypeIds = toJS(dataTypeIds.forcing)[category.id]
    if (!forcingData || !forcingData[category.id] || !forcingDataTypeIds) {
      return <div style={{ width: '100%', color: 'black' }}></div>
    }
    // const forcingDataTypeIds = dataTypeIds.forcing.get(category.id).toJS()
    const data = _flatten(forcingData[category.id]).map(
      d => ({ ...d, typeName: _get(d, 'type.name') })
    )
    return <ForcingDataChart dataRecords={data} dataTypeIds={forcingDataTypeIds} category={category} key={category.id} today={today} />
  }
  return <div>
    <Section>
      <CatchmentControl title="ลุ่มน้ำ" />
      {catchmentId && <StationControl title="สถานี" />}
    </Section>
    {stationIds && stationIds.length && responseCategories.map(category =>
      <Section key={category.id}>
        <ControlSection>
          <DataTypeControl
            kind="response"
            category={category}
            dataTypes={category.dataTypes.nodes}
          />
        </ControlSection>
        <ChartSection style={{ marginTop: '-88px' }}>
          <div className="chartTitle">{category.name}</div>
          {$responseData(category)}
        </ChartSection>
      </Section>
    )}
    {forcingCategories.map(category =>
      <Section key={category.id}>
        <ControlSection>
          <DataTypeControl
            kind="forcing"
            category={category}
            dataTypes={category.dataTypes.nodes}
          />
        </ControlSection>
        <ChartSection>
          <div className="chartTitle">{category.name} ({_get(categories.find(c => c.id === category.id), 'unit')})</div>
          {$forcingData(category)}
        </ChartSection>
      </Section>
    )}
  </div>
}

export default compose(
  graphql(categoriesQuery, {
    name: 'categories',
    props: ({
      categories: {
        loading,
        responseDataCategories,
        forcingDataCategories,
        refetch
      }
    }) => ({
      loading,
      refetch,
      responseCategories: _get(responseDataCategories, 'nodes', []),
      forcingCategories: _get(forcingDataCategories, 'nodes', [])
    })
  }),
  inject('view'),
  inject('data'),
  observer
)(Controls)



// WEBPACK FOOTER //
// ./src/modules/Monitoring/Controls.js